"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthSessionHandler = void 0;
var _1 = require(".");
var WebServiceError_1 = require("./exceptions/WebServiceError");
var OAuthSessionHandler = /** @class */ (function () {
    function OAuthSessionHandler(username, clientId, clientSecret, refreshToken, accessToken, appVersion, errorCallback, refreshTokenCallback) {
        var _this = this;
        this.invalidateSessionId = function (_, callback) {
            // Nothing to invalidate.
            if (callback) {
                callback();
            }
        };
        this.getSessionId = function (connection, callback) {
            connection.callWithoutSession('LogIn', {
                userName: _this.username,
                appVersion: _this.appVersion,
                createSessionCookie: connection.supportsGetItemPreviewMethod
            }, function (result) {
                var newSessionId = result.SessionId;
                if (!newSessionId) {
                    var error = new Error('Successful login but no session came.');
                    if (_this.errorCallback) {
                        _this.errorCallback(error);
                    }
                    else {
                        throw error;
                    }
                    return;
                }
                if (callback) {
                    callback(newSessionId);
                }
            }, function (result) {
                var error = new WebServiceError_1.WebServiceError(result.ReturnCode, 'Unable to login. Error response follows.\n' + JSON.stringify(result));
                if (_this.errorCallback) {
                    _this.errorCallback(error);
                }
                else {
                    throw error;
                }
            }, {
                'Authorization': 'Bearer ' + _this.accessToken
            }, undefined, function (error) {
                var _a;
                if (((_a = error) === null || _a === void 0 ? void 0 : _a.statusCode) === 401) {
                    _this.getNewAccessToken(connection, function (tokenData) {
                        _this.accessToken = tokenData.access_token;
                        if (!tokenData.error) {
                            _this.getSessionId(connection, callback);
                        }
                    });
                    return;
                }
                if (!_this.errorCallback)
                    throw error;
                _this.errorCallback(error);
            });
        };
        this.getNewAccessToken = function (connection, callback) {
            _1.OAuthHelper.refreshToken(connection.wsUrl, _this.clientId, _this.clientSecret, _this.refreshToken, function (tokenData) {
                try {
                    if (_this.refreshTokenCallback) {
                        _this.refreshTokenCallback(tokenData);
                    }
                }
                catch (error) {
                    if (_this.errorCallback) {
                        _this.errorCallback(new Error('Refresh token callback failed.\n' + JSON.stringify(error)));
                    }
                }
                callback(tokenData);
            });
        };
        if (!username || !refreshToken || !clientId || !clientSecret) {
            throw new Error("Non of the arguments 'username', 'clientId', 'clientSecret', 'refreshToken' can be empty.");
        }
        this.username = username;
        this.refreshToken = refreshToken;
        this.accessToken = accessToken;
        this.appVersion = appVersion;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.errorCallback = errorCallback;
        this.refreshTokenCallback = refreshTokenCallback;
    }
    return OAuthSessionHandler;
}());
exports.OAuthSessionHandler = OAuthSessionHandler;
